import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
export const useDisconnectStanfordTax = (param)=>{
    let { failureToastTestId } = param;
    const { api } = useStoreActions();
    const { t: stanfordTaxTexts } = useLocaleKeys('integrations.setup.stanfordTax');
    const { refresh: refreshIntegrations } = useIntegrations({
        enabled: false
    });
    const { mutate, isPending } = useMutationState({
        mutationFn: ()=>api.stanfordTax.disconnect(),
        toasts: {
            errorMessage: stanfordTaxTexts.disconnectFailed(),
            errorTestId: failureToastTestId
        },
        onSuccess: async ()=>{
            await refreshIntegrations({
                throwOnError: false
            });
        }
    });
    return {
        disconnectStanfordTax: mutate,
        isLoading: isPending
    };
};
